import React, { useEffect, useRef, useState } from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';

const scaleRegex = /(?:scaleX\()([0-9.-]+)/;
const initFontSizes = [
  { key: '6', text: '6', value: 6 },
  { key: '8', text: '8', value: 8 },
  { key: '10', text: '10', value: 10 },
  { key: '12', text: '12', value: 12 },
  { key: '14', text: '14', value: 14 },
  { key: '16', text: '16', value: 16 },
  { key: '18', text: '18', value: 18 },
  { key: '20', text: '20', value: 20 },
  { key: '24', text: '24', value: 24 },
  { key: '28', text: '28', value: 28 },
  { key: '32', text: '32', value: 32 },
  { key: '36', text: '36', value: 36 },
  { key: '42', text: '42', value: 42 },
  { key: '48', text: '48', value: 48 },
  { key: '56', text: '56', value: 56 },
  { key: '64', text: '64', value: 64 },
  { key: '72', text: '72', value: 72 },
  { key: '82', text: '82', value: 82 },
  { key: '96', text: '96', value: 96 },
  { key: '104', text: '104', value: 104 },
  { key: '120', text: '120', value: 120 },
  { key: '144', text: '144', value: 144 },
];

const FontSize = props => {
  const enabledEditorId = useSelector(state => state.design.enabledEditorId);
  const currentFontSize = useSelector(state => state.design.fontSize);
  const [fontSizes, setFontSizes] = useState(initFontSizes);
  const [selectedFontSize, setSelectedFontSize] = useState(null);
  const fontSizeRef = useRef(12);
  const scaleRef = useRef(1);
  const initRef = useRef(true);

  useEffect(() => {
    const targetTransform = _.get(
      document.getElementById(`_${props.entityId}_`),
      'style.transform',
    );
    if (targetTransform) scaleRef.current = scaleRegex.exec(targetTransform)[1];
    const observer = new MutationObserver(mutations => {
      const newScale = scaleRegex.exec(mutations[0].target.style.transform)[1];
      if (newScale !== scaleRef.current) {
        scaleRef.current = newScale;
        addNewFontSize(fontSizeRef.current);
      }
    });

    try {
      observer.observe(document.getElementById(`_${props.entityId}_`), {
        attributes: true,
        attributeFilter: ['style'],
      });
    } catch (error) {}

    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (initRef.current) {
      initRef.current = false;
      return;
    }
    const targetTransform = document.getElementById(`_${props.entityId}_`).style.transform;
    if (targetTransform) {
      const newScale = scaleRegex.exec(targetTransform)[1];
      if (newScale !== scaleRef.current) {
        scaleRef.current = newScale;
        addNewFontSize(fontSizeRef.current);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.entityId]);

  useEffect(() => {
    fontSizeRef.current = currentFontSize;
    addNewFontSize(currentFontSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentFontSize]);

  const onFontSizeChange = (e, { value }) => {
    setSelectedFontSize(value);

    const newStyle = {
      type: 'fontSize',
      all: props.entityId !== enabledEditorId,
      value: Math.round((value / 0.75 / scaleRef.current + Number.EPSILON) * 1000) / 1000,
    };
    props.onChange(newStyle);
  };

  const addNewFontSize = fontSize => {
    let size = Math.floor(fontSize * scaleRef.current * 10) / 10;
    if (!size) size = '--';
    let temp = [...fontSizes, { key: `${size}`, text: `${size}`, value: size }];
    temp = _.sortBy(temp, 'value');
    temp = _.sortedUniqBy(temp, 'value');
    setFontSizes(temp);
    if (selectedFontSize !== size) setSelectedFontSize(size);
  };

  return (
    <Dropdown
      className="button"
      options={fontSizes}
      placeholder="- -"
      search
      selection
      fluid
      allowAdditions
      compact
      scrolling
      additionLabel=""
      searchInput="number"
      value={selectedFontSize}
      onAddItem={(e, { value }) => addNewFontSize(value)}
      onChange={onFontSizeChange}
    />
  );
};

FontSize.propTypes = {
  entityId: PropTypes.number,
  onChange: PropTypes.func,
  selectAll: PropTypes.func,
  ids: PropTypes.any,
};

export default FontSize;
